import React from 'react';
import { Trans } from '@lingui/macro';
import clsx from 'clsx';

export type SidebarSectionTitleProps = {
  children: React.ReactNode;
  className?: string;
  actionHref?: string;
  showAction?: boolean;
  actionLabel?: React.ReactNode;
  onAction?: () => void;
  target?: string;
};

export function SidebarSectionTitle({
  children,
  className,
  actionHref,
  actionLabel = <Trans id="general.edit">Edit</Trans>,
  onAction,
  showAction = !!onAction || !!actionHref,
  target = actionHref ? '_blank' : undefined,
}: SidebarSectionTitleProps) {
  return (
    <div className={clsx('b-sidebar__title -style_bordered', className)}>
      {showAction && (onAction || actionHref) && (
        <a
          className="b-link -type_inserted"
          target={target}
          href={actionHref}
          onClick={
            onAction &&
            ((event) => {
              event.preventDefault();

              onAction();
            })
          }
        >
          {actionLabel}
        </a>
      )}
      {children}
    </div>
  );
}
